<template>
  <v-container style="width: 800px;">
    <v-card>
      <v-container>
        <v-card-title>{{ isUpdateMode ? $t('update-btn') : $t('save-btn') }}</v-card-title>

        <!-- Enter 리로드 방지 -->
        <form @submit.prevent>
          <v-flex sm8>
            <v-text-field
              v-model.trim="email"
              label="email address"
              v-validate="'required|max:30'"
              :counter="30"
              data-vv-name="email"
              :error-messages="errors.collect('email')"
              :disabled="isUpdateMode"
              required
            ></v-text-field>
          </v-flex>

          <v-switch
            v-model="isDisabled"
            label="メール受信する"
            color="info"
            hide-details
          ></v-switch>

          <div class="button-area">
            <v-layout row wrap>
              <v-flex xs12 sm6 class="pr-2">
                <v-btn
                  block
                  color="#4C728A"
                  dark
                  :to="{ name: 'admin/order-mail-receiver' }"
                >
                  <v-icon dark left>arrow_back</v-icon>
                  {{ $t('back-btn') }}
                </v-btn>
              </v-flex>

              <v-flex xs12 sm6>
                <v-btn
                  block
                  color="success"
                  dark
                  @click="submit"
                  :loading="loading2"
                  :disabled="loading2"
                >
                  <v-icon class="ma-2" dark small>save</v-icon>
                  {{ isUpdateMode ? $t('update-btn') : $t('save-btn') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </form>
      </v-container>
    </v-card>    
  </v-container>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import ServerApiCallService from '@/services/ServerApiCallService.js'

Vue.use(VeeValidate)

export default {
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      isUpdateMode: false,
      loading2: false,
      isDisabled: false,
      email: '',
    }
  },
  async created() {
    ServerApiCallService.setAppJs(this.getAppComponent())

    const { email = '' } = this.$route.params || {}
    this.isUpdateMode = email !== ''
    this.email = email

    if (this.isUpdateMode) {
      await this.loadStore(email)   // 서버에서 isActive 등을 다시 가져옴
    } else {
      this.isDisabled = false           // 신규는 기본 활성
    }
  },
  methods: {
    /**
     * 라우터로 전달받은 활성 상태를 Boolean으로 변환한다.
     */
    toBoolean(value) {
      return value === true ||
        value === 'true' ||
        value === '1' ||
        value === 1
    },
    /**
     * 공통 상위 애플리케이션 컴포넌트를 반환한다.  
     */
    getAppComponent() {
      return this.$parent.$parent.$parent
    },
    /**
     * 수정 모드일 때 email 현재 상태를 다시 조회한다.
     */
    async loadStore(email) {
      try {
        const { data } =
          await ServerApiCallService.orderMailReceiverByEmail({
            email
          })

        this.isDisabled = this.toBoolean(
          data.orderMailReceiver.isActive
        )
      } catch (error) {
        console.error(
          '店舗情報の取得に失敗しました。',
          error.response || error
        )
        this.getAppComponent().showErrorDialog(this.$t('loadFailed'))
      }
    },    

    async submit() {
      if (this.loading2) {
        return
      }

      const valid = await this.$validator.validateAll()
      if (!valid) {
        this.getAppComponent().showErrorDialog(this.$t('hasInputError'))
        return
      }

      const request = {
        email: this.email,
        isActive: this.isDisabled
      }
      const sendContext = {
        hasDialogComponent: this.getAppComponent(),
        forwardNameOnClose: 'admin/order-mail-receiver'
      }

      this.loading2 = true
      
      try {
        await (this.isUpdateMode
          ? ServerApiCallService.orderMailReceiverUpdate(request, sendContext)
          : ServerApiCallService.orderMailReceiverRegister(request, sendContext))
      } catch (error) {
        console.error('受信者情報の保存に失敗しました。', error.response || error)
        this.getAppComponent().showErrorDialog(this.$t('saveFailed'))
      } finally {
        this.loading2 = false
      }      
    }
  }
}
</script>

<style scoped>
.button-area {
  margin-top: 55px;
  margin-bottom: 20px;
}
</style>